import fixDateTimezone from '../../../utils/fixDateTimezone';
import formatDate from '../../../utils/formatDate';

// Ð¡ÑÐ¾ÑÑ Ð¾ÑÐ´Ð°ÑÑ Ð´Ð°Ð½Ð½ÑÐµ Ñ Ð·Ð°Ð´ÐµÑÐ¶ÐºÐ¾Ð¹ 1â2 Ð´Ð½Ñ: Ð¾ÑÑÑÐ°Ð²Ð°Ð½Ð¸Ðµ Ð±Ð¾Ð»ÑÑÐµ ÑÑÐ¾Ð³Ð¾ â Ð¿Ð¾ÑÐ° Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ²ÐµÐ¶Ð¸Ðµ Ð²ÑÐ³ÑÑÐ·ÐºÐ¸.
export const STORE_LAG_DAYS = 3;

const time = (iso) => (iso ? formatDate(fixDateTimezone(iso), true) : '');
// 'YYYY-MM-DD' â 'DD.MM.YYYY' Ð±ÐµÐ· ÑÐ°ÑÐ¾Ð²ÑÑ Ð¿Ð¾ÑÑÐ¾Ð²
const day = (value) => (value ? value.slice(0, 10).split('-').reverse().join('.') : '');
const daysBetween = (from, to) => Math.round((Date.parse(to) - Date.parse(from)) / 86400000);

export const isBusy = (status) => status?.state === 'requested' || status?.state === 'running';

// Ð¡ÑÑÐ¾ÐºÐ° ÑÑÐ°ÑÑÑÐ° Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ: ÑÑÐ¾ ÑÐµÐ¹ÑÐ°Ñ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð´Ð¸Ñ Ð¸Ð»Ð¸ ÑÐµÐ¼ Ð·Ð°ÐºÐ¾Ð½ÑÐ¸Ð»Ð¾ÑÑ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐµ
export const refreshSummary = (status) => {
  if (!status) return { text: 'ÐÐ°Ð³ÑÑÐ·ÐºÐ°â¦', tone: 'muted' };
  if (status.state === 'requested') return { text: 'Ð Ð¾ÑÐµÑÐµÐ´Ð¸: Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ Ð½Ð°ÑÐ½ÑÑÑÑ Ð² ÑÐµÑÐµÐ½Ð¸Ðµ Ð¼Ð¸Ð½ÑÑÑ', tone: 'busy' };
  if (status.state === 'running') return { text: 'ÐÐ´ÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ, ÑÑÐ¾ Ð¾ÐºÐ¾Ð»Ð¾ Ð¼Ð¸Ð½ÑÑÑâ¦', tone: 'busy' };
  if (!status.finishedAt) return { text: 'ÐÐ±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹ ÐµÑÑ Ð½Ðµ Ð±ÑÐ»Ð¾', tone: 'muted' };
  if (status.ok) return { text: `ÐÐ±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¾ ${time(status.finishedAt)}`, tone: 'ok' };
  return { text: `ÐÑÐ¸Ð±ÐºÐ° Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ ${time(status.finishedAt)}: ${status.message || 'Ð¿ÑÐ¸ÑÐ¸Ð½Ð° Ð½ÐµÐ¸Ð·Ð²ÐµÑÑÐ½Ð°'}`, tone: 'error' };
};

// ÐÑÑÐ¾ÑÐ½Ð¸ÐºÐ¸ ÑÑÑÐ°Ð½Ð¾Ð²Ð¾Ðº: Ð¿Ð¾ ÐºÐ°ÐºÐ¾Ð¹ Ð´ÐµÐ½Ñ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ñ Ð´Ð°Ð½Ð½ÑÐµ. Ð¡ÑÐ¾ÑÑ Ð²Ð½Ð¾ÑÑÑ Ð²ÑÑÑÐ½ÑÑ Ð¸Ð· CSV, AppsFlyer ÑÑÐ½ÐµÑÑÑ ÑÐ°Ð¼.
// today â ÑÐµÐ³Ð¾Ð´Ð½ÑÑÐ½Ð¸Ð¹ Ð´ÐµÐ½Ñ 'YYYY-MM-DD' Ð² ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½Ðµ (Ð¿Ð°ÑÐ°Ð¼ÐµÑÑ, ÑÑÐ¾Ð±Ñ Ð¿ÑÐ¾Ð²ÐµÑÑÑÑ ÑÐµÑÑÐ¾Ð¼).
export const sourceRows = (installs, today = fixDateTimezone().format('YYYY-MM-DD')) => {
  const last = (...keys) => keys.map((k) => installs?.[k]?.lastDay).filter(Boolean).sort().pop() || null;
  const rows = [
    { title: 'iOS â App Store Connect', lastDay: last('iosStore'), manual: true },
    { title: 'Android â Google Play', lastDay: last('androidStore'), manual: true },
    { title: 'AppsFlyer (iOS Ð¸ Android)', lastDay: last('iosAppsflyer', 'androidAppsflyer'), manual: false },
  ];

  return rows.map((r) => ({
    title: r.title,
    lastDay: r.lastDay ? day(r.lastDay) : 'Ð½ÐµÑ Ð´Ð°Ð½Ð½ÑÑ',
    stale: r.manual && (!r.lastDay || daysBetween(r.lastDay, today) > STORE_LAG_DAYS),
  }));
};

const PLATFORMS = { ios: 'iOS', android: 'Android' };

// ÐÑÐ¾Ð³ Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ Ð¿Ð¾ ÐºÐ°Ð¶Ð´Ð¾Ð¼Ñ ÑÐ°Ð¹Ð»Ñ: Ð¿Ð»Ð°ÑÑÐ¾ÑÐ¼Ð° Ð¸ Ð´Ð¸Ð°Ð¿Ð°Ð·Ð¾Ð½ Ð´Ð°Ñ Ð»Ð¸Ð±Ð¾ Ð¿ÑÐ¸ÑÐ¸Ð½Ð° Ð¾ÑÐºÐ°Ð·Ð°
export const importLines = (files = []) =>
  files.map((f) =>
    f.ok
      ? { ok: true, text: `${f.name}: ${PLATFORMS[f.platform] || f.platform}, ${f.days} Ð´Ð½., ${day(f.from)} â ${day(f.to)}` }
      : { ok: false, text: `${f.name}: ${f.error}` }
  );

export const errorText = (error) =>
  error?.response?.data?.errorMessage || error?.response?.data?.message || error?.message || 'ÐÐµÐ¸Ð·Ð²ÐµÑÑÐ½Ð°Ñ Ð¾ÑÐ¸Ð±ÐºÐ°';

